import { render, staticRenderFns } from "./my-tickets.vue?vue&type=template&id=a9d1b8d0&"
import script from "./my-tickets.vue?vue&type=script&lang=js&"
export * from "./my-tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports